import { Title } from "../../../../../components/Title";
import claimPayIcon from '../../../../../assets/claim-pay-icon.svg';

export const PropDescriptionTitle = () => <Title title='Property Description (Optional)'>
  <img alt='claimpay' src={claimPayIcon} />
</Title>